import React, { PropsWithChildren } from "react";
import classNames from "classnames";
import { TestClaimFormattedRejectCode } from "@/types/appTypes/transmissions";

interface Props {
  rejectCodes?: Array<TestClaimFormattedRejectCode>;
  extraClasses?: string;
  type?: string;
  icon?: boolean;
  shadow?: boolean;
  alignText?: string;
  testId?: string;
}

export const RejectCodesBox: React.FC<Props> = ({
  rejectCodes,
  extraClasses,
  type = "success",
  icon = true,
  shadow = true,
  children,
  alignText = "center",
  testId = "",
}: PropsWithChildren<Props>): JSX.Element => {
  const messageBoxClasses = classNames("message-box-wrapper", extraClasses, type, { "no-icon": !icon }, { "no-shadow": !shadow });
  const messageContentClasses = classNames("message-content", alignText);

  let mainMessage = null;
  if (rejectCodes.length > 0) {
    mainMessage = (
      <span className="message-box-message" data-testid={testId}>
        {rejectCodes.map((RejectCodeObj) => RejectCodeObj.rejectCode).join(", ")}
      </span>
    );
  }

  return (
    <div className={messageBoxClasses}>
      <div className={messageContentClasses}>
        {mainMessage}
        {children}
      </div>
    </div>
  );
};

export default RejectCodesBox;
